import { Component, inject, Input } from '@angular/core';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { MaskPasswordPipe } from '../../../content/pipes/mask-password.pipe';
import { I18nService } from '../../../core/services/i18n.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'sps-masked-password',
  imports: [
    Button,
    MaskPasswordPipe,
    Tooltip
  ],
  templateUrl: './sps-masked-password.component.html',
})
export class SpsMaskedPasswordComponent {

  i18n = inject(I18nService);
  private clipboard = inject(Clipboard);

  @Input() password: string;
  @Input() showPassword: boolean = false;

  autoMaskTimerId: any = null;

  changePasswordMask() {
    if (this.showPassword) {
      this.showPassword = false;
      if (this.autoMaskTimerId) {
        clearTimeout(this.autoMaskTimerId);
      }
    } else {
      this.showPassword = true;
      this.autoMaskTimerId = setTimeout(() => {
        this.showPassword = false;
        this.autoMaskTimerId = null;
      }, 30000);
    }
  }

  protected copyPasswordToClipboard() {
    this.clipboard.copy(this.password);
  }
}
